import React from 'react';

const ImageTextOverlay = props =>
  (<div className="ImageTextOverlay">
    <img className="ImageTextOverlay-img" src={props.imageLink} alt="magic" />
    <p className="ImageTextOverlay-text light uppercase">{props.imageText}</p>
  </div>);

export default ImageTextOverlay;
